<template>
    <SafetyVideos></SafetyVideos>
</template>

<script>
import SafetyVideos from "../../components/Safety/SafetyVideos.vue";
import AuthLayout from "../../Layouts/AuthLayout.vue";

export default {
    name: "Safety_Videos",
    components: { SafetyVideos, AuthLayout },
};
</script>